import React, { useEffect, useState } from "react";
import "./AboutUs.css";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Carousel from "react-bootstrap/Carousel";
// import Button from "react-bootstrap/Button";
import video from "../../assets/video.mp4";
import { useRef } from "react";

// Se importan los iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCar,
  faCarSide,
  faCarBattery,
} from "@fortawesome/free-solid-svg-icons";

// se importan las imagenes
// import local1 from "../../assets/local1.jpeg";
// import local2 from "../../assets/local2.jpeg";
// import local3 from "../../assets/local3.jpeg";
// import local4 from "../../assets/local4.jpeg";
// import local5 from "../../assets/local5.jpeg";
// import local6 from "../../assets/local6.jpg";

const AboutUs = () => {
  const [fontSize, setFontSize] = useState("fs-5");
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1025) {
        setFontSize("fs-6");
      } else if (window.innerWidth <= 1220) {
        setFontSize("fs-6");
      } else {
        setFontSize("fs-5");
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize(); // Llama a handleResize al cargar la página para establecer el tamaño de fuente inicial

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const videoRef = useRef(null);

  const handleVideoClick = () => {
    if (videoRef.current) {
      videoRef.current.muted = !videoRef.current.muted; // Alterna el audio
    }
  };

  useEffect(() => {
    // Forzar la reproducción en dispositivos móviles
    if (videoRef.current) {
      const playPromise = videoRef.current.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          // Si falla, intenta reproducirlo en una ligera demora
          setTimeout(() => {
            videoRef.current.play().catch((err) => console.log("Error al reproducir:", err));
          }, 500);
        });
      }
    }
  }, []);

  return (
    <>
      <div className="bkg-a text-center ps-4 pe-4" id="aboutus">
        <h2 className="pt-5 fs-1 fw-bold text-light">CONOCENOS</h2>
        <div className="container">
          <p className={`${fontSize} text-light fs-5 p-4 pb-1`}>
            Somos una empresa del rubro automotriz dedicada a la revisión,
            diagnostico y asesoramiento en el estado y funcionamiento de
            vehiculos usados. Revisión automotriz nace a raiz de la preocupación
            de nuestros clientes a la hora de querer cambiar sus vehiculos y
            encontrarse con distintos problemas o dudas sobre los estados de los
            mismos. Por ello nos fuimos formando y adquiriendo los mejores
            equipos del mercado, así como tambien nuestro amplio conocimiento
            mecánico para brindar un servicio acertado, logrando asi garantía de
            confianza y fidelidad.
          </p>
          <p className={`${fontSize} text-light fs-5`}>
            ✅️Comprar un auto usado no es una tarea fácil, más aún cuando la
            gran mayoría de nosotros no tiene los conocimientos técnicos sobre
            mecánica. Los vehículos de segunda mano ofrecen grandes ventajas
            como el precio, el bajo impacto de la depreciación o la rapidez de
            la compra. Sin embargo, una decisión apresurada, sin tomar en cuenta
            algunos riesgos, puede traértenos un sinfín de problemas que más
            vale prevenir.
          </p>
          <p className={`${fontSize} text-light fs-5`}>
            ✅️Revisa antecedentes del auto. Es fundamental que conozcamos el
            historial del vehículo y que podamos buscar la mayor cantidad de
            información posible. En los tiempos actuales, es indispensable saber
            si el vehículo tuvo accidentes o si existe la presencia de alguna
            reparacion en mal estado
          </p>
          <p className={`${fontSize} text-light fs-5`}>
            ✅️Inspección visual. Cualquier visita que hagas con un particular o
            a una concesionaria procura asesorarte por profesionales en mecánica
            automotriz que permitan detectar el real estado del vehículo, es
            decir, si ha tenido eventuales choques o alguna falla mecánica.
            Siempre estas revisiones deben hacerse a plena luz del día. ¿En qué
            fijarse?
          </p>
          <p className={`${fontSize} text-light fs-5`}>
            ✅️Revisa los daños en la carrocería o pintura, principalmente si
            existen abolladuras cercas a las llantas o si existen hundimiento en
            la parte donde se encuentra el motor. También comprueba si se
            presentan fugas de fluidos o cualquier daño visible en el tapizado y
            de los materiales del interior. Además, de comprobar el estado de
            los parabrisas, asientos, el estado de las luces y si las puertas
            están en perfectas condicionadas.
          </p>
        </div>
        {/* <Carousel
          controls={false}
          indicators={false}
          touch={true}
          className="container-a mt-5"
        >
          <Carousel.Item interval={5000}>
            <div className="d-flex flex-column justify-content-center shadow">
              <img
                src={local1}
                className="img-fluid shadow img-round"
                alt="Imagen del local 1"
              />
            </div>
          </Carousel.Item>
          <Carousel.Item interval={5000}>
            <div className="d-flex flex-column justify-content-center shadow">
              <img
                src={local2}
                className="img-fluid shadow img-round"
                alt="Imagen del local 2"
              />
            </div>
          </Carousel.Item>{" "}
          <Carousel.Item interval={5000}>
            <div className="d-flex flex-column justify-content-center shadow">
              <img
                src={local3}
                className="img-fluid shadow img-round"
                alt="Imagen del local 3"
              />
            </div>
          </Carousel.Item>
          <Carousel.Item interval={5000}>
            <div className="d-flex flex-column justify-content-center shadow">
              <img
                src={local4}
                className="img-fluid shadow img-round"
                alt="Imagen del local 4"
              />
            </div>
          </Carousel.Item>
          <Carousel.Item interval={5000}>
            <div className="d-flex flex-column justify-content-center shadow">
              <img
                src={local5}
                className="img-fluid shadow img-round"
                alt="Imagen del local 5"
              />
            </div>
          </Carousel.Item>
          <Carousel.Item interval={5000}>
            <div className="d-flex flex-column justify-content-center shadow">
              <img
                src={local6}
                className="img-fluid shadow img-round"
                alt="Imagen del local 6"
              />
            </div>
          </Carousel.Item>
        </Carousel> */}
        <div className="video-container rounded p-3">
          <video
            ref={videoRef}
            autoPlay
            muted
            loop
            playsInline
            className="video-k rounded shadow"
            onClick={handleVideoClick} // Evento para activar el audio
          >
            <source src={video} type="video/mp4" />
          </video>
        </div>
        <Container fluid className="text-center container">
          <Row className="align-items-start justify-content-center grid-a">
            <Col>
              <FontAwesomeIcon icon={faCar} className="icon" />
              <p className="fw-semibold text-light mt-3 fs-3">
                Chequeo de Motor
              </p>
              <p className="text-light mt-3 fs-5">
                Revision exterior y interior, medida de aceite, agua y otros
              </p>
            </Col>
            <Col>
              <FontAwesomeIcon icon={faCarBattery} className="icon" />
              <p className="fw-semibold text-light mt-3 fs-3">
                Pruebas de Bateria
              </p>
              <p className="text-light mt-3 fs-5">
                Chequeo de vida util, pruebas de alternador y carga
              </p>
            </Col>
            <Col>
              <FontAwesomeIcon icon={faCarSide} className="icon" />
              <p className="fw-semibold text-light mt-3 fs-3">
                Pintura y Choques
              </p>
              <p className="text-light mt-3 fs-5">
                Revision de choques, partes masilladas y pintadas
              </p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default AboutUs;
